import Vue from 'vue'
import Router from 'vue-router'
import jiankongset from '@/components/jiankong'
import DeviceVideo from '@/components/DeviceVideo'
import deviceList from '@/components/deviceList'
import deviceMenu from '@/components/DeviceMenu'
Vue.use(Router);
export default new Router({

	routes: [{
		path: "/jiankongset",
		name: "jiankongset",
		component: jiankongset
	},{
		path: "/deviceVideo",
		name: "DeviceVideo",
		component: DeviceVideo
	},{
		path: "/deviceList",
		name: "deviceList",
		component: deviceList
	},{
		path: "/deviceMenu",
		name: "deviceMenu",
		component: deviceMenu
	}]
})
